export const API_HOST = process.env.API_HOST;
import { valueByInputType } from "@stofloos/utils/sw-constants";
import { readObjects } from "@stofloos/actions/crud";
import findIndex from "lodash-es/findIndex";

export const INIT_REQUEST = "INIT_REQUEST";

export const SET_QUERY_FILTERS = "SET_QUERY_FILTERS";
export const UNSET_QUERY_FILTERS = "UNSET_QUERY_FILTERS";
export const UNSET_QUERY_FILTER = "UNSET_QUERY_FILTER";

export const SET_PAGE = "SET_PAGE";
export const INCREMENT_PAGE = "INCREMENT_PAGE";
export const DECREMENT_PAGE = "DECREMENT_PAGE";
export const SET_PAGE_LIMIT = "SET_PAGE_LIMIT";

export const SET_ORDER_BY = "SET_ORDER_BY";

export const REQUEST_FETCHING = "REQUEST_FETCHING";
export const REQUEST_FAILURE = "REQUEST_FAILURE";
export const REQUEST_SUCCESS = "REQUEST_SUCCESS";

export const SET_REQUEST = "SET_REQUEST";
export const SET_REQUEST_META = "SET_REQUEST_META";
export const SET_REQUEST_SINGLE = "SET_REQUEST_SINGLE";

export function initRequest(requestId, endpoint) {
	return dispatch => {
		dispatch({
			type: INIT_REQUEST,
			requestId,
			endpoint
		});
	};
}

let searchTimer = 0;

export function hasRequest(requestId, request) {
	if (requestId === undefined) {
		console.error("No requestId provided");
		return false;
	}

	if (request === undefined) {
		console.error(
			"No request found on requestId " + requestId + ". Call action initRequest from actions/requests.js"
		);
		return false;
	} else {
		return true;
	}
}

export function searchAll(e) {
	let value = e.target.value;
	let requestId = e.target.dataset.requestid;
	let columnNumber = e.target.dataset.columnnumber;
	let columnString = e.target.dataset.columnstring;
	let stringSearch = e.target.hasAttribute("string-search");
	clearTimeout(searchTimer);
	return dispatch => {
		searchTimer = setTimeout(function() {
			if (value) {
				if (!stringSearch && parseInt(value)) {
					dispatch(setQueryFilter(requestId, columnNumber, "eq", parseInt(value)));
				} else {
					if (parseInt(value)) {
						dispatch(setQueryFilter(requestId, columnNumber ? columnNumber : columnString, "ilike", value + "%"));
					} else {
						dispatch(setQueryFilter(requestId, columnString, "ilike", "%" + value + "%"));
					}
				}
			} else {
				dispatch(unsetQueryFilter(requestId, columnNumber + "eq"));
				dispatch(unsetQueryFilter(requestId, columnNumber + "ilike"));
				dispatch(unsetQueryFilter(requestId, columnString + "ilike"));
			}
			dispatch(setPage(requestId, 1));
			dispatch(readObjects(requestId));
		}, 250);
	};
}

export function search(e) {
	if (!e.target.dataset.operator) {
		console.error("Missing data-operator on the input element.");
		return;
	}

	if (!e.target.dataset.requestid) {
		console.error("Missing requestId-operator on the input element.");
		return;
	}
	clearTimeout(searchTimer);

	return dispatch => {
		let target = e.target;
		let requestId = target.dataset.requestid;
		dispatch(setPage(requestId, 1));
		searchTimer = setTimeout(function() {
			let value = valueByInputType(target);
			let operator = target.dataset.operator;
			let column = target.dataset.column;

			if (value && operator === "ilike") {
				dispatch(setQueryFilter(requestId, column, operator, "%" + value + "%"));
			} else if (value) {
				dispatch(setQueryFilter(requestId, column, operator, value));
			} else {
				dispatch(unsetQueryFilter(requestId, column + operator));
			}

			dispatch(readObjects(requestId));
		}, 250);
	};
}

export function toggleOrderBy(requestId, column, cast, auto) {
	return (dispatch, getState) => {
		let direction;
		if (getState().requests[requestId].orderBy) {
			let oldDirection = getState().requests[requestId].orderBy.direction;
			if (oldDirection === "desc") {
				direction = "asc";
			} else {
				direction = "desc";
			}
		} else {
			direction = "asc";
		}
		dispatch(setOrderBy(requestId, column, direction, cast, auto));
	};
}

export function setOrderBy(requestId, column, direction, cast, auto) {
	return (dispatch, getState) => {
		dispatch({
			type: SET_ORDER_BY,
			requestId,
			column,
			direction,
			cast
		});
		if (auto) {
			dispatch(setPage(requestId, 1));
			dispatch(readObjects(requestId));
		}
	};
}

export function setQueryFilters(requestId, updatedQueryFilters) {
	return dispatch => {
		dispatch({
			type: SET_QUERY_FILTERS,
			requestId,
			updatedQueryFilters
		});
	};
}

export function setQueryFilter(requestId, name, operator, value) {
	return (dispatch, getState) => {
		//Check if request already has queryfilters
		let queryFilters = [];
		if (getState().requests[requestId] && getState().requests[requestId].queryFilters) {
			queryFilters = [...getState().requests[requestId].queryFilters];
		}

		let updatedQueryFilters = [];
		const id = name + operator;
		let newFilter = { id: id, name: name, operator: operator, value: value };
		//Check if filter already exists in request, if so overwrite otherwise add new value
		if (queryFilters) {
			updatedQueryFilters = queryFilters;
			let filterExists = false;
			for (let key in queryFilters) {
				if (queryFilters[key].id === newFilter.id) {
					filterExists = true;
					queryFilters[key] = newFilter;
					break;
				}
			}

			if (!filterExists) {
				updatedQueryFilters.push(newFilter);
			}
		} else {
			updatedQueryFilters.push(newFilter);
		}
		dispatch({
			type: SET_QUERY_FILTERS,
			requestId,
			updatedQueryFilters
		});
	};
}

export function unsetQueryFilters(requestId) {
	return dispatch => {
		dispatch({
			type: UNSET_QUERY_FILTERS,
			requestId
		});
	};
}

export function unsetQueryFilter(requestId, id) {
	return (dispatch, getState) => {
		const queryFilters = getState().requests[requestId].queryFilters;

		let index = findIndex(queryFilters, ["id", id]);

		dispatch({
			type: UNSET_QUERY_FILTER,
			requestId,
			index
		});
	};
}

export function setPageLimit(requestId, pageLimit) {
	return dispatch => {
		dispatch({
			type: SET_PAGE_LIMIT,
			requestId,
			pageLimit
		});
	};
}

export function incrementPage(requestId, append) {
	return (dispatch, getState) => {
		const state = getState();
		const request = state.requests[requestId];
		if (request.hasMorePages) {
			dispatch({
				type: INCREMENT_PAGE,
				requestId
			});
			dispatch(readObjects(requestId, null, append));
		}
	};
}

export function decrementPage(requestId) {
	return (dispatch, getState) => {
		const state = getState();
		const request = state.requests[requestId];
		if (request.page > 1) {
			dispatch({
				type: DECREMENT_PAGE,
				requestId
			});
		}
		dispatch(readObjects(requestId));
	};
}

export const requestFetching = (requestId, message) => {
	return {
		type: REQUEST_FETCHING,
		requestId,
		message
	};
};

export const requestFailure = (requestId, message) => {
	return {
		type: REQUEST_FAILURE,
		requestId,
		message
	};
};

export const requestSuccess = (requestId, message) => {
	return {
		type: REQUEST_SUCCESS,
		requestId,
		message
	};
};
export const setSingle = (requestId, single) => {
	return {
		type: SET_REQUEST_SINGLE,
		requestId,
		single
	};
};

export const setPage = (requestId, page) => {
	return {
		type: SET_PAGE,
		requestId,
		page
	};
};
export const setRequest = (requestId, isFetching, isFailure, isSuccess) => {
	return {
		type: SET_REQUEST,
		requestId,
		isFetching,
		isFailure,
		isSuccess
	};
};

export const setRequestMeta = (requestId, totalPages, totalObjects, objectId) => {
	return {
		type: SET_REQUEST_META,
		requestId,
		totalPages,
		totalObjects,
		objectId
	};
};
